<template>
  <div>
    <PageAllow controller="Settings" action="businessSetting" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{ $t("LKLPaySetting.title") }}
          <v-spacer></v-spacer>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
            <v-container>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("LKLPaySetting.lkl_sub_account_enable") +
                    $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-radio-group
                    row
                    v-model="settings.lkl_sub_account_enable"
                  >
                    <v-radio
                      :label="$t('LKLPaySetting.off')"
                      :key="0"
                      :value="0"
                    />
                    <v-radio
                      :label="$t('LKLPaySetting.on')"
                      :key="1"
                      :value="1"
                    />
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{  $t("LKLPaySetting.lkl_auto_sub_account_enable") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-radio-group
                    row
                    v-model="settings.lkl_auto_sub_account_enable"
                  >
                    <v-radio
                      :label="$t('LKLPaySetting.off')"
                      :key="0"
                      :value="0"
                    />
                    <v-radio
                      :label="$t('LKLPaySetting.on')"
                      :key="1"
                      :value="1"
                    />
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row align="center" v-if="settings.lkl_auto_sub_account_enable == 1">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{  $t("LKLPaySetting.lkl_auto_sub_account_days") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-text-field
                    v-model="settings.lkl_auto_sub_account_days"
                    dense
                    single-line
                    suffix="天以前"
                    type="number"
                    style="max-width: 150px"
                  >
                  </v-text-field>
                  <span>{{  $t("LKLPaySetting.lkl_auto_sub_account_days_hint", [settings.lkl_auto_sub_account_days]) }}</span>
                </v-col>
              </v-row>
            </v-container>
        </v-card-text>
      </v-card>
      <v-card class="page-opts">
        <v-card-title>
          <v-row dense>
            <v-col cols="12">
              <v-btn color="success" block @click="save()">
                <v-icon small class="pe-1">fa-save</v-icon>
                {{ $t("CRUD.save") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-sheet>
  </div>
</template>

<script>
import Setting from "@/api/settings";
import SubAccountSettings from "@/api/sub_account_settings";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import { mapState } from "vuex";

export default {
  data: () => ({
    settings: {},
    serverErrors: [],
  }),
  components: {
    PageAllow,
    Breadcrumbs,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("SettingNav.split"),
        disabled: false,
        href: "/settings/sub-account-settings/sub-account-type",
      },
      {
        text: i18n.t("SettingNav.splitInterface"),
        disabled: false,
        href: "/settings/sub-account-settings/sub-account-setting-port",
      },
    ],
    ...mapState(["loading"]),
  },

  mounted() {
    this.getLKLPayFromAPI();
  },

  methods: {
    getLKLPayFromAPI() {
      Setting.settings(
        "keys[]=lkl_sub_account_enable&keys[]=lkl_auto_sub_account_enable&keys[]=lkl_auto_sub_account_days"
      ).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.settings = response.data.settings;
            if (!this.settings.lkl_sub_account_enable) {
              this.settings.lkl_sub_account_enable = 0;
            }
            if (
              this.settings.lkl_auto_sub_account_enable == null ||
              typeof this.settings.lkl_auto_sub_account_enable == "undefined" ||
              this.settings.lkl_auto_sub_account_enable == undefined
            ) {
              //启用自动分账
              this.settings.lkl_auto_sub_account_enable = 0;
            }
            if (
              this.settings.lkl_auto_sub_account_days == null ||
              typeof this.settings.lkl_auto_sub_account_days == "undefined" ||
              this.settings.lkl_auto_sub_account_days == undefined
            ) {
              //自动分账时间范围
              this.settings.lkl_auto_sub_account_days = 5;
            }
          }
        }.bind(this)
      );
    },

    save() {
      SubAccountSettings.saveLKLSetting({
        lkl_sub_account_enable: this.settings.lkl_sub_account_enable,
        lkl_auto_sub_account_enable: this.settings.lkl_auto_sub_account_enable,
        lkl_auto_sub_account_days: this.settings.lkl_auto_sub_account_days,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$router.replace(
              "/settings/sub-account-settings/sub-account-setting-port"
            );
          }
        }.bind(this)
      );
    },
  },
};
</script>

<style>
</style>